var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_519_25584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.375 17.4685H2.5V13.6021C2.5 13.2522 2.22031 12.9688 1.875 12.9688H0.625C0.279687 12.9688 0 13.2522 0 13.6021V18.7351C0 19.4346 0.559766 20.0018 1.25 20.0018H19.375C19.7203 20.0018 20 19.7184 20 19.3685V18.1018C20 17.7519 19.7203 17.4685 19.375 17.4685Z",
    fill: "#132439"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.625 17.4685H17.5V13.6021C17.5 13.2522 17.7797 12.9688 18.125 12.9688H19.375C19.7203 12.9688 20 13.2522 20 13.6021V18.7352C20 19.4346 19.4402 20.0018 18.75 20.0018H0.625C0.279688 20.0018 0 19.7184 0 19.3685V18.1018C0 17.7519 0.279688 17.4685 0.625 17.4685Z",
    fill: "#132439"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5618 7.91488V1.60156C11.5618 1.3427 11.3519 1.13281 11.0931 1.13281H8.90556C8.6467 1.13281 8.43681 1.3427 8.43681 1.60156V7.91488H6.63763C5.8024 7.91488 5.38412 8.92469 5.9747 9.51531L9.33638 12.877C9.70252 13.2431 10.2961 13.2431 10.6622 12.877L14.0239 9.51531C14.6145 8.92473 14.1962 7.91488 13.361 7.91488H11.5618Z",
    fill: "#132439"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_519_25584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.1daa56f28d2f7b3c4c6618224f2a75c1.svg";
export { ForwardRef as ReactComponent };